import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {RootState} from 'modules';
import {seekingAction} from 'modules/video';
import Skip from 'components/player/controlbar/Skip';

/**
 * 되감기/빨리감기 컨테이너
 */

const SKIP_TIME = 10; // seconds

const SkipContainer = () => {
  const dispatch = useDispatch();
  const {
    video: {playingTime, totalDuration},
  } = useSelector(({video}: RootState) => ({
    video,
  }));

  /**
   * 10초 뒤로
   */
  const onClickRewind = () => {
    let time = playingTime - SKIP_TIME;
    if (time <= 0) {
      time = 0;
    }
    dispatch(seekingAction(time));
  };

  /**
   * 10초 앞으로
   */
  const onClickForward = () => {
    let time = playingTime + SKIP_TIME;
    if (time > totalDuration) {
      time = totalDuration;
    }
    dispatch(seekingAction(time));
  };

  return <Skip onClickRewind={onClickRewind} onClickForward={onClickForward} />;
};

export default SkipContainer;
